<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
    stroke-linejoin="round" width="22" height="22">
    <polyline points="9 18 15 12 9 6" />
  </svg>
</template>

<script>
export default {
  name: 'NextIcon'
}
</script>
